import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import ModalBaseContainer from '@max/leez-modal-base-container';
import './index.scss';
const BottomSliderModal = (props) => {
    const { visible, onClose, children, heightInRpx = '1038rpx', topBanner } = props;
    return <ModalBaseContainer visible={visible} type="slide" slideFrom="bottom" onMaskPress={onClose} onClosed={onClose} contentStyle={{
            height: heightInRpx
        }}>
      <View x-if={topBanner}>
        {topBanner}
      </View>
      <View className="bottom-slider-modal">
        {children}
      </View>
    </ModalBaseContainer>;
};
export default memo(BottomSliderModal);
